import React, { useState } from "react";
import MainLayout from "../../layout/mainLayout";
import { Row, Col, Button, Accordion } from "react-bootstrap";
import "./index.scss";
import { useEffect } from "react";
import { getProductListing, readData } from "../../service/order/orderService";
import { useSelector } from "react-redux";
import {
  formatAmount,
  getParamsFromURL,
  renderOrderStatus,
  renderStatus,
  setParamsInURL,
  getCodeFromUrl,
} from "../../utils/helper";
import dateFormat from "dateformat";
import { TickInfoIcon } from "../../assets/images/svg/svg";
import { useLocation, useNavigate } from "react-router-dom";
import { buyNow, profile, paymentSummary } from "../../utils/router/constant";
import { AG_CODE } from "../../utils/commonConstant";
import CustomerDetails from "./customerDetails";

const Summary = () => {
  const nav = useNavigate();
  const location = useLocation();
  const [orderId, setOrderId] = useState(null);
  const [entityid, setEntityId] = useState(null);
  const [isAccordionOpen, setIsAccordionOpen] = useState(true);
  const detailsData = useSelector(
    (state) => state.orders.selectedOrder.detailsData
  );
  const customerData = useSelector((state) => state.common.customerData);
  const agDetails = useSelector((state) => state.common.agDetails);

  const productData = useSelector(
    (state) => state.orders.selectedOrder.productData
  );
  useEffect(() => {
    const fetchCode = async () => {
      await getParamsFromURL(location).then((params) => {
        if (params) {
          const token = params["token"];
          if (token) {
            localStorage.setItem("token", token);
          }
          setOrderId(params["orderId"]);
          setEntityId(params["entityid"]);
        } else {
          console.error("No parameters found");
        }
      });
    };
    fetchCode();
  }, [location]);

  useEffect(() => {
    if (orderId) {
      readData(orderId, "ODR");
      getProductListing(orderId);
    }
  }, [orderId]);

  const handleContinue = async () => {
    const paramObject = {
      entityid: entityid,
      orderId: orderId,
    };
    const params = await setParamsInURL(location, paramObject);
    const agCode = getCodeFromUrl();
    if (agDetails?.profile_enabled === false) {
      // profile_enabled false (MSCDA): profile (if not filled yet) and proposal
      // are filled after the order; the profile page goes on to the proposal
      nav(`${customerData?.is_first_login === 1 ? profile : buyNow}?${params}`);
    } else if (agCode === AG_CODE || agCode === "chem") {
      nav(`${paymentSummary}?${params}`);
    } else {
      nav(`${buyNow}?${params}`);
    }
    // if (detailsData.order_type === "RENEWAL") {
    //   nav(`${buyNow}?${params}`);
    // } else if (customerData.is_first_login === 1) {
    //   nav(`${profile}?${params}`);
    // } else {
    //   nav(`${buyNow}?${params}`);
    // }
  };

  // const handlePrevious = async () => {
  //   nav(-1);
  // };
  // console.log(detailsData)
  const getCoverValue = (orderData) => {
    let cover = 0;
    if (orderData && orderData?.variant_json) {
      const data = JSON.parse(orderData?.variant_json);
      productData.map((proData) => {
        let id = proData?.entityid;
        cover = data[id]?.cover;
        return formatAmount(cover);
      });
    }
    return formatAmount(cover);
  };

  return (
    <MainLayout>
      <div className="summary-container">
        <div className="order-info">
          <div className="order-header">
            <div className="order-id">Order ID : {detailsData.code}</div>
            <div className="order-status">
              {renderStatus(detailsData.status)}
            </div>
          </div>
          <div className="order-date">
            Order Date :{" "}
            {detailsData.created_date
              ? dateFormat(detailsData.created_date, "dd mmm yyyy")
              : "-"}
          </div>
        </div>

        <Row>
          <Col xs="12">
            <Accordion className="summary-personal-detail">
              <Accordion.Item eventKey="0">
                <Accordion.Header
                  onClick={() => setIsAccordionOpen(!isAccordionOpen)}
                >
                  Relationship & Customer Details
                </Accordion.Header>
                <Accordion.Body>
                  <CustomerDetails customerData={customerData} />
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
          <Col md="8" xs="12">
            <Row>
              <Col xs="12" className="product-container">
                <div className="product-card">
                  <div className="card--img ">
                    <img src={detailsData.product_logo_url} alt="Insurance" />
                  </div>
                  <div className="product-details">
                    <div className="product-name">{detailsData.name}</div>
                    {/* <div className="product-price">
                      {formatAmount(detailsData.gross_amount, null, null, null)}
                    </div> */}
                  </div>
                  <div className="product-details-summary">
                    <div className="product-label-cover">Cover</div>
                    <div className="product-value-cover">
                      {formatAmount(detailsData.cover_amount)}
                    </div>
                  </div>
                  <div className="product-details-summary">
                    <div className="product-label-premium">Premium</div>
                    <div className="product-value-premium">
                      {formatAmount(detailsData.gross_amount)}
                    </div>
                  </div>
                </div>
              </Col>

              <Col xs="12" className="product-container">
                <div className="summary-card">
                  <div className="summary-title">Order Summary</div>
                  <div className="premium-details">Premium Breakup</div>
                  <hr className="divider" />
                  {productData.map((product, index) => (
                    <div className="summary-content">
                      <div className="card--img">
                        <img
                          src={product.oem_media_url || "default-image.png"}
                          alt={product.name || "Insurance"}
                        />
                      </div>
                      <div className="summary-details">
                        <div className="summary-name">{product.name}</div>
                        <div className="summary-description">
                          {product.psp_name || "N/A"}
                        </div>
                      </div>
                      <div className="summary-price">
                        {formatAmount(product.premium_amount, null, null, null)}
                      </div>
                    </div>
                  ))}
                </div>
              </Col>

              <Col
                sm={
                  productData?.some((product) =>
                    product.product_info?.Add_Ons?.some(
                      (addon) => addon.value !== "no"
                    )
                  )
                    ? "6"
                    : "12"
                }
                xs="12"
                className="product-container"
              >
                <div className="summary-card">
                  <div className="summary-card-title">Coverages</div>
                  {productData?.length > 0 && (
                    <div className="attributes-container">
                      <Row>
                        {(() => {
                          const hasAddons = productData?.some((product) =>
                            product.product_info?.Add_Ons?.some(
                              (addon) => addon.value !== "no"
                            )
                          );
                          return (
                            <>
                              {productData[0].product_info?.Attributes.map(
                                (attribute, idx) => (
                                  <Col
                                    md={hasAddons ? 12 : 6}
                                    xs={12}
                                    key={`attr-0-${idx}`}
                                  >
                                    <div className="form-head">
                                      <span className="tick-icon">
                                        <TickInfoIcon />
                                      </span>{" "}
                                      <span>
                                        {attribute.label}: {attribute.value}
                                      </span>
                                    </div>
                                  </Col>
                                )
                              )}
                              {productData.length > 1 &&
                                productData[1].product_info?.Attributes.map(
                                  (attribute, idx) => {
                                    const isDuplicate =
                                      productData[0].product_info?.Attributes.some(
                                        (attr) => attr.value === attribute.value
                                      );
                                    return !isDuplicate ? (
                                      <Col
                                        md={hasAddons ? 12 : 6}
                                        xs={12}
                                        key={`attr-1-${idx}`}
                                      >
                                        <div className="form-head">
                                          <span className="tick-icon">
                                            <TickInfoIcon />
                                          </span>{" "}
                                          <span>
                                            {attribute.label}: {attribute.value}
                                          </span>
                                        </div>
                                      </Col>
                                    ) : null;
                                  }
                                )}
                            </>
                          );
                        })()}
                      </Row>
                    </div>
                  )}
                </div>
              </Col>

              {productData?.some((product) =>
                product.product_info?.Add_Ons?.some(
                  (addon) => addon.value !== "no"
                )
              ) && (
                  <Col sm="6" xs="12" className="product-container">
                    <div className="summary-card">
                      <div className="summary-card-title">Add-ons</div>
                      {productData?.length > 0 && (
                        <div>
                          {/* Set to track already rendered add-ons */}
                          {productData[0].product_info?.Add_Ons?.map(
                            (addon, idx) =>
                              addon.value !== "no" && (
                                <div key={idx} className="form-head">
                                  <span className="tick-icon">
                                    <TickInfoIcon />
                                  </span>{" "}
                                  {addon.label} : {addon.value}
                                </div>
                              )
                          )}

                          {/* Render add-ons from the second product if not already rendered */}
                          {productData.length > 1 &&
                            productData[1].product_info?.Add_Ons?.map(
                              (addon, idx) => {
                                // Check if the add-on label already exists in the first product's add-ons
                                const isDuplicate =
                                  productData[0].product_info?.Add_Ons.some(
                                    (existingAddon) =>
                                      existingAddon.label === addon.label
                                  );
                                // If it is not a duplicate, render it
                                return !isDuplicate
                                  ? addon.value !== "no" && (
                                    <div key={idx} className="form-head">
                                      <span className="tick-icon">
                                        <TickInfoIcon />
                                      </span>{" "}
                                      {addon.label} : {addon.value}
                                    </div>
                                  )
                                  : null;
                              }
                            )}
                        </div>
                      )}
                    </div>
                  </Col>
                )}
            </Row>
            <div className="button-container">
              <div className="summary-bottom">
                {/* <Button
                  variant="primary"
                  className="previous"
                  onClick={() => handlePrevious()}
                >
                  Previous
                </Button> */}
                {(detailsData.status === "PAYMENT_PENDING" ||
                  detailsData.status === "PROPOSAL_PENDING" ||
                  detailsData.status === "PAYMENT_FAILED") && (
                    <Button
                      variant="primary"
                      className="continue"
                      onClick={() => handleContinue()}
                    >
                      Continue
                    </Button>
                  )}
              </div>
            </div>
          </Col>
          <Col md="4" xs="12" className="summary-personal-card">
            <CustomerDetails customerData={customerData} />
          </Col>
        </Row>
      </div>
    </MainLayout>
  );
};

export default Summary;
